import { createSlice } from '@reduxjs/toolkit';
import { machineApi } from '@custom/rtk-apis/machine/addMachine';

const machineApiSlice = createSlice({
    name: 'machineApiSlice',
    initialState: {
      machinePayload: null,
      status: null,
      loading: false,
      error: null,
      success: false,
    },
    reducers: {
      reset: (state) => {
        state.machinePayload = null;
        state.status = null;
        state.loading = false;
        state.error = null;
        state.success = false;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(machineApi.fetchMachineApi.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.success = false;
        })
        .addCase(machineApi.fetchMachineApi.fulfilled, (state, action) => {
          console.log('Fetched payload:', action.payload);
          state.machinePayload = action.payload;
          state.status = action.payload.status;
          state.loading = false;
          state.success = true;
        })
        .addCase(machineApi.fetchMachineApi.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.success = false;
        });
    },
  });

  export default machineApiSlice.reducer;
  export const { reset } = machineApiSlice.actions
